<div>
    <canvas
    class="mb-3"
     baseChart width="400" height="400"
    [type]="'bar'"
    [data]="barChartData"
    [options]="barChartOptions"
    [legend]="barChartLegend"
    >
    </canvas>
</div>